/**
 * Main Application Component for MarIA Health Care
 *
 * Routes:
 * - / : Landing page with GDPR consent
 * - /chat : Protected chat interface (uses ADK /run_sse)
 * - /mi-salud : Protected health survey (SurveyJS)
 * - /estadisticas : Protected statistics
 *
 * @see Issue #177 - Frontend Firebase Auth Integration
 * @see Issue #XX - Health Survey Integration
 *
 * UPDATE (2026-01-10): Migrated to official Google ADK pattern.
 * UPDATE (2026-01-13): Added health survey with SurveyJS.
 */
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import PrivateRoute from '@/components/PrivateRoute'
import LandingPage from '@/pages/LandingPage'
import ChatPage from '@/pages/ChatPage'
import EstadisticasPage from '@/pages/EstadisticasPage'
import EncuestaSaludPage from '@/pages/EncuestaSaludPage'

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public route - Landing with GDPR consent */}
                    <Route path="/" element={<LandingPage />} />

                    {/* Protected Routes - Require authentication + consent */}
                    <Route element={<PrivateRoute />}>
                        <Route path="/chat" element={<ChatPage />} />
                        <Route path="/mi-salud" element={<EncuestaSaludPage />} />
                        <Route path="/estadisticas" element={<EstadisticasPage />} />
                    </Route>

                    {/* Legacy routes redirect */}
                    <Route path="/login" element={<Navigate to="/" replace />} />
                    <Route path="/register" element={<Navigate to="/" replace />} />
                    <Route path="/encuesta" element={<Navigate to="/mi-salud" replace />} />

                    {/* Catch-all redirect */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    )
}

export default App
